import { z } from 'zod'
import { dbEntitySchema, listQueryZodFields } from './system'
import { entityAnalyticsSchema } from './track'

export const trackDailyEntityTypeSchema = z.enum(['venue', 'event'])

export const trackDailySchema = dbEntitySchema.extend({
  date: z.coerce.date(),
  entityType: trackDailyEntityTypeSchema,
  entityId: z.string(),
  venue: z.string().optional(),
  organization: z.string().optional(),
  measures: entityAnalyticsSchema,
})

export const trackDailyUpsertArgsSchema = z.object({
  date: z.coerce.date(),
  entityType: trackDailyEntityTypeSchema,
  entityId: z.string(),
  venue: z.string().optional(),
  organization: z.string().optional(),
  measures: entityAnalyticsSchema,
})

export const trackDailyListQuerySchema = z.object({
  ...listQueryZodFields,
  entityType: trackDailyEntityTypeSchema.optional(),
  entityId: z.string().optional(),
  venueId: z.string().optional(),
  organizationId: z.string().optional(),
  dateStart: z.coerce.date().optional(),
  dateEnd: z.coerce.date().optional(),
})

export const trackDailyListResponseSchema = z.object({
  data: z.array(trackDailySchema),
  count: z.number().int().nonnegative(),
})
